import { Button } from '@mui/material';
import CasinoIcon from '@mui/icons-material/Casino';
import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { ConfirmDialog } from '../ConfirmDialog';
import { useDrawIndividualEntryStartNumbers } from '../../api/hooks/useIndividualEntries';

interface Props {
  categoryId: number;
  disabled?: boolean;
}

export function DrawStartNumbersButton({ categoryId, disabled }: Props) {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const drawMut = useDrawIndividualEntryStartNumbers(categoryId);

  const handleConfirm = () => {
    drawMut.mutate(undefined, {
      onSuccess: () => {
        enqueueSnackbar('Startovní čísla byla vylosována', { variant: 'success' });
        setOpen(false);
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError: (e: any) => {
        enqueueSnackbar(
          e?.response?.data?.message ?? 'Losování selhalo',
          { variant: 'error' },
        );
      },
    });
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<CasinoIcon />}
        onClick={() => setOpen(true)}
        disabled={disabled || drawMut.isPending}
      >
        Losovat startovní čísla
      </Button>

      <ConfirmDialog
        open={open}
        title="Vylosovat startovní čísla?"
        message="Opravdu vylosovat startovní čísla? Stávající čísla budou přepsána."
        confirmText="Vylosovat"
        destructive
        loading={drawMut.isPending}
        onCancel={() => (drawMut.isPending ? undefined : setOpen(false))}
        onConfirm={handleConfirm}
      />
    </>
  );
}
